acom_app.models.Menu = Backbone.Model.extend({
    defaults: function () {
        var helper = acom_app.models.helper
        var menus = Object.keys(helper.get('menus'))

        return {
            slug: menus.length > 0 ? menus[0] : '',
            rule: 'all'
        }
    },
    fields: {
        first_select: {
            type: 'select',
            label: '',
            class: 'col-xs-12',
            variants: {},
        },
        second_select: {
            type: 'select',
            label: '',
            class: 'col-xs-12',
            variants: {},
        }
    }
})